module.exports = __webpack_public_path__ + "img/Boy_020020.35740392.png";